var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { ThemeProvider } from '@mui/material';
import { Routes } from './Routes';
import { theme } from './style/theme';
import { Toaster } from 'ui-lib';
import { MultiAuthProvider } from 'ui-lib';
function App() {
    return (_jsx(Toaster, { children: _jsx(MultiAuthProvider, { children: _jsx(ThemeProvider, __assign({ theme: theme }, { children: _jsx(Routes, {}) })) }) }));
}
export default App;
